/**
 * Thread types: chat threads with messages and checkpoint summaries.
 * Threads mirror external chat streams; messages can reference external content items.
 */

import { z } from 'zod';
import { CheckpointSummarySchema } from './checkpoints';

export const ThreadMetaSchema = z.object({
  threadId: z.string(),
  workspaceId: z.string(),
  /** External source (e.g. slack, discord); null if internal-only */
  externalSource: z.string().nullable(),
  /** Id in the external system (e.g. channel_id + thread_ts) */
  externalId: z.string().nullable(),
  title: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ThreadMeta = z.infer<typeof ThreadMetaSchema>;

export const ThreadMessageSchema = z.object({
  messageId: z.string(),
  threadId: z.string(),
  /** Role: user, assistant, system */
  role: z.enum(['user', 'assistant', 'system']),
  content: z.string(),
  /** Optional reference to a ContentItem (e.g. doc, Notion page) */
  contentItemId: z.string().nullable(),
  /** External message id if synced from external chat */
  externalId: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ThreadMessage = z.infer<typeof ThreadMessageSchema>;

export const ThreadCheckpointSummarySchema = CheckpointSummarySchema.extend({
  threadId: z.string(),
});
export type ThreadCheckpointSummary = z.infer<typeof ThreadCheckpointSummarySchema>;
